import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import Eliminar from "./Eliminar";
import ModalPrueba from "./ModalPrueba";
import {
  addPruebas,
  disableEstado,
  EliminarMasivo,
} from "../../../redux/reducers/Pruebas/PruebasSlice";
import { useDispatch } from "react-redux";

const Tablaprueba = ({ datosTabla }) => {
  const [itemClicked, setItemClicked] = useState(undefined);
  const dispatch = useDispatch();
  const columns = [
    {
      label: "Nombre ",
      name: "name",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "ip",
      label: "IP ",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "user",
      label: "Usuario",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "st",
      label: "ST",
      options: {
        filter: true,
        display: true,
      },
    },

    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        display: true,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (value) => <Eliminar id={datosTabla[value].id} />,
      },
    },
  ];

  const options = {
    expandableRowsOnClick: true,
    responsive: "standard",
    searchPlaceholder: "Buscar ",
    tableBodyHeight: "estándar",
    tableBodyMaxHeight: "estándar",
    selectableRows: "multiple",
    customToolbarSelect: () => {},
    onRowsPerPageChange: 10,
    print: false,
    viewColumns: true,
    filter: false,
    download: false,
    onRowClick: (e, meta) => {
      handleOpenModal(meta.dataIndex);
    },
    onTableChange: (action, tableState) => {
      if (datosTabla !== undefined) {
        try {
          if (tableState.selectedRows.data.length > 0) {
            dispatch(disableEstado(false));
          } else {
            dispatch(disableEstado(true));
          }
          let data2 = [];
          const dataId = [];

          data2 = tableState.selectedRows.data;
          data2.forEach((x) => {
            dataId.push(datosTabla[x.index].id);
          });
          dispatch(EliminarMasivo(dataId));
        } catch (error) {
          console.log("Error" + error);
          dispatch(addPruebas([]));
        }
      } else {
        dispatch(addPruebas([]));
        dispatch(disableEstado(true));
      }
    },

    textLabels: {
      body: {
        noMatch: "Registros no encontrados",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
        sortable: true,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
        onPageChange: true,
      },
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        downloadCsv: "Descargar",
      },

      viewColumns: {
        title: "Mostrar columnas",
      },
      selectedRows: {
        text: "Filas seleccionadas",
      },
      TableHead: {
        root: {
          sortable: false,
          color: "white",
          backgroundColor: "#007B7B",
        },
      },
    },
  };

  const handleOpenModal = (index) => {
    setItemClicked(datosTabla[index]);
  };

  const handleDeleteItemClicked = () => {
    setItemClicked(undefined);
  };

  return (
    <div>
      <MUIDataTable data={datosTabla} columns={columns} options={options} />
      {itemClicked && (
        <ModalPrueba
          onHide={handleDeleteItemClicked}
          nombre={itemClicked.name}
          id={itemClicked.id}
          ip={itemClicked.ip}
        />
      )}
    </div>
  );
};

export default Tablaprueba;
